const {
  contains,
  curry,
  filter,
  has,
  tap,
} = require('ramda')
const { Future } = require('ramda-fantasy')

const cached = {}
const isCached = function (type, id) {
  return has(type, cached) && contains(id, cached[type])
}

function makeCached (type, id) {
  if (!has(type, cached)) {
    cached[type] = []
  }
  cached[type].push(id)
}

function dispatcherGetList (type, streams, req, predicate, id) {
  if (isCached(type, id)) {
    return Future.of(filter(predicate(id), streams.main.extract()))
  }
  return req(id)
    .map(tap((result) => {
      streams.addAll.put(result)
      makeCached(type, id)
    }))
}

module.exports = curry(dispatcherGetList)
